import { render, staticRenderFns } from "./acquiringGroups.vue?vue&type=template&id=455353f6&scoped=true"
import script from "./acquiringGroups.vue?vue&type=script&lang=js"
export * from "./acquiringGroups.vue?vue&type=script&lang=js"
import style0 from "./acquiringGroups.vue?vue&type=style&index=0&id=455353f6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "455353f6",
  null
  
)

export default component.exports